import React from "react";

const FeedbackButton = ({
  isSubmitting,
  isReview,
  setClearanswers,
  GradingToggle,
  checklabel,
  label,
  IsFeedbackGenerating,
  feedback_label,
  ...props
}) => {
  return isReview ? (
    <button
      className="btn fw-bold btn-lg fs-8 btpy-2 rounded-5 px-3"
      type="button"
      onClick={(e) => {
        e.preventDefault();
        setClearanswers(true);
      }}
      style={{
        borderColor: "#DCDCE3",
        color: "#2E58D4",
        backgroundColor: "#ffff",
      }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 17 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_8457_8219)">
          <path
            d="M3.18783 15.5832V12.0415M3.18783 4.95817V1.4165M1.41699 3.18734H4.95866M1.41699 13.8123H4.95866M9.20866 2.12484L7.98028 5.31862C7.78052 5.83799 7.68065 6.09767 7.52533 6.31611C7.38767 6.5097 7.21852 6.67885 7.02493 6.8165C6.80649 6.97182 6.54681 7.0717 6.02744 7.27146L2.83366 8.49984L6.02744 9.72821C6.54681 9.92797 6.80649 10.0279 7.02493 10.1832C7.21852 10.3208 7.38767 10.49 7.52533 10.6836C7.68065 10.902 7.78052 11.1617 7.98028 11.6811L9.20866 14.8748L10.437 11.6811C10.6368 11.1617 10.7367 10.902 10.892 10.6836C11.0297 10.49 11.1988 10.3208 11.3924 10.1832C11.6108 10.0279 11.8705 9.92797 12.3899 9.72821L15.5837 8.49984L12.3899 7.27146C11.8705 7.0717 11.6108 6.97182 11.3924 6.8165C11.1988 6.67885 11.0296 6.5097 10.892 6.31611C10.7367 6.09767 10.6368 5.83799 10.437 5.31861L9.20866 2.12484Z"
            stroke="#2E58D4"
            stroke-width="1.41667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_8457_8219">
            <rect width="17" height="17" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <span className="ps-1">Clear answers</span>
    </button>
  ) : isSubmitting ? (
    <button
      class="btn fw-bold btn-lg fs-8 btpy-2 rounded-5 px-3"
      style={{
        borderColor: "#DCDCE3",
        color: "#2E58D4",
        backgroundColor: "#ffff",
      }}
      type="button"
      disabled
    >
      <span
        class="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
      {checklabel ? checklabel : "Checking"}
    </button>
  ) : label ? (
    <button
      className={"btn fw-bold btn-lg fs-8 btpy-2 rounded-5 me-2"}
      style={{
        borderColor: "#DCDCE3",
        color: "#2E58D4",
        backgroundColor: "#ffff",
      }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 17 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_8457_8219)">
          <path
            d="M3.18783 15.5832V12.0415M3.18783 4.95817V1.4165M1.41699 3.18734H4.95866M1.41699 13.8123H4.95866M9.20866 2.12484L7.98028 5.31862C7.78052 5.83799 7.68065 6.09767 7.52533 6.31611C7.38767 6.5097 7.21852 6.67885 7.02493 6.8165C6.80649 6.97182 6.54681 7.0717 6.02744 7.27146L2.83366 8.49984L6.02744 9.72821C6.54681 9.92797 6.80649 10.0279 7.02493 10.1832C7.21852 10.3208 7.38767 10.49 7.52533 10.6836C7.68065 10.902 7.78052 11.1617 7.98028 11.6811L9.20866 14.8748L10.437 11.6811C10.6368 11.1617 10.7367 10.902 10.892 10.6836C11.0297 10.49 11.1988 10.3208 11.3924 10.1832C11.6108 10.0279 11.8705 9.92797 12.3899 9.72821L15.5837 8.49984L12.3899 7.27146C11.8705 7.0717 11.6108 6.97182 11.3924 6.8165C11.1988 6.67885 11.0296 6.5097 10.892 6.31611C10.7367 6.09767 10.6368 5.83799 10.437 5.31861L9.20866 2.12484Z"
            stroke="#2E58D4"
            stroke-width="1.41667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_8457_8219">
            <rect width="17" height="17" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <span className="ps-1">{label}</span>
    </button>
  ) : (
    <button
      type="button"
      onClick={() => GradingToggle()}
      className={IsFeedbackGenerating ? "disabled_btn btn fw-bold btpy-2 fs-8 btn-lg rounded-5 px-4" : "btn fw-bold btpy-2 fs-8 btn-lg rounded-5 px-4"}
      style={{
        borderColor: "#DCDCE3",
        color: "#2E58D4",
        backgroundColor: "#ffff",
      }}
      disabled={IsFeedbackGenerating}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 17 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_8457_8219)">
          <path
            d="M3.18783 15.5832V12.0415M3.18783 4.95817V1.4165M1.41699 3.18734H4.95866M1.41699 13.8123H4.95866M9.20866 2.12484L7.98028 5.31862C7.78052 5.83799 7.68065 6.09767 7.52533 6.31611C7.38767 6.5097 7.21852 6.67885 7.02493 6.8165C6.80649 6.97182 6.54681 7.0717 6.02744 7.27146L2.83366 8.49984L6.02744 9.72821C6.54681 9.92797 6.80649 10.0279 7.02493 10.1832C7.21852 10.3208 7.38767 10.49 7.52533 10.6836C7.68065 10.902 7.78052 11.1617 7.98028 11.6811L9.20866 14.8748L10.437 11.6811C10.6368 11.1617 10.7367 10.902 10.892 10.6836C11.0297 10.49 11.1988 10.3208 11.3924 10.1832C11.6108 10.0279 11.8705 9.92797 12.3899 9.72821L15.5837 8.49984L12.3899 7.27146C11.8705 7.0717 11.6108 6.97182 11.3924 6.8165C11.1988 6.67885 11.0296 6.5097 10.892 6.31611C10.7367 6.09767 10.6368 5.83799 10.437 5.31861L9.20866 2.12484Z"
            stroke="#2E58D4"
            stroke-width="1.41667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_8457_8219">
            <rect width="17" height="17" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <span className="ps-1">{feedback_label}</span>
    </button>
  );
};

export default FeedbackButton;
